import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const conciergeRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "AI agents", breadcrumbNavigate: false },
    children: [
      {
        path: "conversations",
        handle: { breadcrumb: "Conversations" },
        async lazy() {
          const [
            { ConciergeConversationsPage },
            { ConciergeSupportV2RedirectGuard },
          ] = await Promise.all([
            import("./conversations/concierge-conversations-page"),
            import("./concierge-support-v2-redirect-guard"),
          ]);
          return {
            element: (
              <ConciergeSupportV2RedirectGuard>
                <ConciergeConversationsPage />
              </ConciergeSupportV2RedirectGuard>
            ),
          };
        },
      },
      {
        path: "monitoring",
        handle: { breadcrumb: "Monitoring" },
        async lazy() {
          const [
            { aiAgentMonitoringPage: AiAgentMonitoringPage },
            { ConciergeSupportV2RedirectGuard },
          ] = await Promise.all([
            import("./monitoring/ai-agent-monitoring-page"),
            import("./concierge-support-v2-redirect-guard"),
          ]);
          return {
            element: (
              <ConciergeSupportV2RedirectGuard>
                <AiAgentMonitoringPage />
              </ConciergeSupportV2RedirectGuard>
            ),
          };
        },
      },
      {
        path: "testing",
        handle: { breadcrumb: "Testing" },
        async lazy() {
          const [{ AiAgentTestingPage }, { ConciergeSupportV2RedirectGuard }] =
            await Promise.all([
              import("./testing/ai-agent-testing-page"),
              import("./concierge-support-v2-redirect-guard"),
            ]);
          return {
            element: (
              <ConciergeSupportV2RedirectGuard>
                <AiAgentTestingPage />
              </ConciergeSupportV2RedirectGuard>
            ),
          };
        },
      },
      {
        path: "knowledge",
        handle: { breadcrumb: "Knowledge" },
        async lazy() {
          const { AgentKnowledgePage } =
            await import("../agent-knowledge/page");
          return { Component: AgentKnowledgePage };
        },
      },
      {
        path: "about",
        async lazy() {
          const { AboutConcierge } = await import("./about");
          return { Component: AboutConcierge };
        },
      },
      {
        path: "onboard",
        async lazy() {
          const { SelfServePage } =
            await import("./self-serve/self-serve-page");
          return { Component: SelfServePage };
        },
      },
      {
        path: "preview",
        async lazy() {
          const { PreviewPage } = await import("./preview/preview-page");
          return { Component: PreviewPage };
        },
      },
    ],
  },
];
